import { getMessages } from '../../../../../../../store/constants';

export const CUSTOM_BUTTON_HIDE = getMessages().getText('card_form_custom_empty_hide');
export const CUSTOM_BUTTON_SHOW = getMessages().getText('card_form_custom_empty_show');
